import { Skeleton } from 'components/Skeleton/Skeleton'

import Styles from './ShareSheet.module.scss'

export const LoadingState = () => {
  return (
    <div className={Styles.loadingState}>
      <Skeleton title={{ width: 48 }} paragraph={false} active />
      <div className={Styles.loadingRow}>
        <div>
          <Skeleton avatar title={{ width: 211 }} paragraph={false} active />
        </div>
        <div>
          <Skeleton title={{ width: 44 }} paragraph={false} active />
        </div>
      </div>
      <div className={Styles.loadingRow}>
        <div>
          <Skeleton avatar title={{ width: 124 }} paragraph={false} active />
        </div>
        <div>
          <Skeleton title={{ width: 68 }} paragraph={false} active />
        </div>
      </div>
      <div className={Styles.loadingRow}>
        <div>
          <Skeleton avatar title={{ width: 150 }} paragraph={false} active />
        </div>
        <div>
          <Skeleton title={{ width: 44 }} paragraph={false} active />
        </div>
      </div>
      <div className={Styles.loadingRow}>
        <div>
          <Skeleton avatar title={{ width: 133 }} paragraph={false} active />
        </div>
        <div>
          <Skeleton title={{ width: 56 }} paragraph={false} active />
        </div>
      </div>
      <div className={Styles.loadingRow}>
        <div>
          <Skeleton avatar title={{ width: 156 }} paragraph={false} active />
        </div>
        <div>
          <Skeleton title={{ width: 56 }} paragraph={false} active />
        </div>
      </div>
    </div>
  )
}
